import type { ReactNode } from 'react'
import AccountTreeOutlined from '@mui/icons-material/AccountTreeOutlined'
import BusinessOutlined from '@mui/icons-material/BusinessOutlined'
import HomeOutlined from '@mui/icons-material/HomeOutlined'
import PeopleOutline from '@mui/icons-material/PeopleOutline'
import QuestionAnswerOutlined from '@mui/icons-material/QuestionAnswerOutlined'
import WorkOutlineOutlined from '@mui/icons-material/WorkOutlineOutlined'
import { MENU_PERMISSIONS } from '../api/session'
import { t } from '../i18n'

/**
 * B1 (sessao 35) - itens do menu lateral e a permissao que cada um exige (T4).
 * Arquivo separado do AppShell para manter o eslint (react-refresh) em 0.
 * s55 (R4, achado A5-s54): "Descricao com IA" SAIU do menu -- levava a uma pagina vazia. A IA volta AO LADO
 * do editor da descricao (R5, s57-58; ADR-0024, estilo Attio), nao como item de menu.
 * s63 (ADR-0033 fatia 1): "Pergunte ao sistema" (nivel 1, sem IA) entra depois de Cargos, com a permissao de cargos.
 */
export interface NavItem {
  to: string
  label: string
  icon: ReactNode
  permission: string | null
}

export const NAV_ITEMS: readonly NavItem[] = [
  // s66 (pedido de Marcelo 24/10/2026 17:47): depois de Inicio, Pergunte ao sistema, Empresa, Unidades e Cargos
  { to: '/', label: t.shell.home, icon: <HomeOutlined />, permission: null },
  { to: '/assistente', label: t.shell.assistant, icon: <QuestionAnswerOutlined />, permission: MENU_PERMISSIONS.jobs },
  // s65 / PE (E5): "Empresa" -- o perfil da empresa (o RH le; so o consultor grava)
  { to: '/empresa', label: t.shell.company, icon: <BusinessOutlined />, permission: MENU_PERMISSIONS.company },
  { to: '/unidades', label: t.shell.units, icon: <AccountTreeOutlined />, permission: MENU_PERMISSIONS.units },
  { to: '/cargos', label: t.shell.jobs, icon: <WorkOutlineOutlined />, permission: MENU_PERMISSIONS.jobs },
  // s69 / 2x: Usuarios da empresa -- so quem lista usuarios (administrador da empresa e da plataforma)
  { to: '/usuarios', label: t.shell.users, icon: <PeopleOutline />, permission: MENU_PERMISSIONS.users },
]

export function visibleNavItems(permissions: readonly string[]): NavItem[] {
  return NAV_ITEMS.filter((i) => i.permission === null || permissions.includes(i.permission))
}

